import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic1.jpg";
import pdf from "../../images/icon/pdf.png";
import doc from "../../images/icon/doc.png";

class ServiceDetail extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Servicios</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> INICIO</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Servicios</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15">Porqué los métodos de inversión se han incrementado?</h2>
											<p className="mb-0">El incremento en la diversidad y el acceso a los métodos de inversión no es casualidad; es el resultado de una "tormenta perfecta" entre tecnología, cambios económicos y una nueva mentalidad social, entre los puntos más impotantes se encuentran: la democratización tecnológica (Fintech), surgimiento de nuevos activos, contexto de inflación y tasas de interés, el acceso a la información y educación.</p>
										</div>
										<div className="row align-items-center">
											<div className="col-md-6 mb-30">
												<ul className="list-check-squer mb-0">
													<li>XXXXXXXXX</li>
													<li>XXXXXXXXX</li>
													<li>XXXXXXXXX</li>
													<li>XXXXXXXXX</li>
													<li>XXXXXXXXX</li>
												</ul>
											</div>
											<div className="col-md-6 mb-30">
												<div className="skillbar-box mb-30">
													<h6 className="title">Avances Tecnológicos</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{width: "96%"}}></p>
														<span className="skill-bar-percent">96%</span>
													</div>
												</div>
												<div className="skillbar-box mb-30">
													<h6 className="title">Desarrollos Financieros</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{width: "79%"}}></p>
														<span className="skill-bar-percent">79%</span>
													</div>
												</div>
												<div className="skillbar-box mb-0">
													<h6 className="title">Apps</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{width: "75%"}}></p>
														<span className="skill-bar-percent">75%</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Preguntas Frecuentes</h4>
											<p className="mb-0">Tecnología Financiera, las dudas cambian un poco, ya no se trata solo de qué comprar, sino de en quién confiar y cómo funcionan estas nuevas plataformas digitales que han desplazado a los bancos tradicionales.</p>
										</div>
										<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>¿Es seguro invertir mi dinero en una App?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Esta es la duda principal. La respuesta depende de la regulación:

¿Está regulada? Antes de depositar, busca si la plataforma está autorizada por entidades oficiales (como la CNBV en México, la SEC en EE. UU. o la CMF en Chile).

Seguridad digital: ¿Ofrece autenticación de dos factores (2FA)? ¿Tienen cifrado de datos? Las Fintech legítimas invierten millones en ciberseguridad.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="1">
												<Accordion.Header>¿Qué pasa si la Fintech quiebra?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">A diferencia de un banco físico, muchas Fintech actúan solo como intermediarios:

Segregación de cuentas: Tus activos (acciones o bonos) suelen estar a tu nombre en un "custodio" independiente. Si la App desaparece, tus títulos siguen siendo tuyos y puedes traspasarlos a otra plataforma.

Seguro de depósito: Algunas cuentan con fondos de protección (como el seguro PROSOFIPO en México) que cubren una parte de tu capital si la entidad llega a quebrar.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="2">
												<Accordion.Header>¿Cómo ganan dinero si no cobran comisiones?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Si la App es "gratis", el usuario suele preguntarse dónde está el truco. Las Fintech monetizan de formas distintas:

Spread de precios: Te venden un activo ligeramente más caro de lo que cuesta en el mercado real.

Pago por flujo de órdenes (PFOF): Reciben pagos de grandes creadores de mercado por enviarles tus operaciones.

Suscripciones Premium: Ofrecen herramientas de análisis avanzadas o tarjetas metálicas por una cuota mensual.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="3">
												<Accordion.Header>¿Qué es el Crowdfunding y qué riesgos tiene?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Es una de las inversiones Fintech más populares. Permite prestar dinero a empresas o proyectos inmobiliarios a cambio de una tasa de interés.

Riesgo de impago: A diferencia de la bolsa, si el proyecto fracasa o el solicitante no paga, recuperar el dinero puede ser un proceso legal largo.

Iliquidez: No puedes "vender" tu inversión al día siguiente; debes esperar a que el proyecto termine (meses o años).</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="4">
												<Accordion.Header>¿Las criptomonedas son parte de las Fintech?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Sí y no. Las Fintech son las plataformas (Exchanges como Binance o Bitso) que facilitan el acceso, pero el activo (Bitcoin, Ethereum) es independiente.

Nota importante: Las inversiones en cripto suelen ser mucho más volátiles y, en muchos países, tienen menos protecciones legales que las inversiones en acciones tradicionales.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="5">
												<Accordion.Header>¿Como puedo tener más información?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">Uno de los principales objetivos de Altheca es brindarte asesoría especializasa en temas de educación financiera, para tener un contacto directo con alguno de nuestros asesores envía WhatsApp al numero 6181006874</p>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</div>
								</div>
								<div className="col-lg-4">
									<aside className="sticky-top pb-1">
										<div className="widget">
											<ul className="service-menu">
												<li className="active"><Link to="/service-detail"><span>Psicología del dinero/sesgos cognitivos</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/service-detail"><span>El "Fisco"/Eficiencia Fiscal</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/service-detail"><span>Más allá de la jubilación</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/service-detail"><span>Gestión de deuda inteligente</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/service-detail"><span>Inflación y el poder adquisitivo</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/service-detail"><span>Seguros y protección de patrimonio</span><i className="fa fa-angle-right"></i></Link></li>
											</ul>
										</div>
										<div className="widget">
											<div className="brochure-bx">
												<h5 className="title-head">Descargas</h5>
												<Link to="#" className="download-link">
													<img src={pdf} alt=""/>
													<h5 className="title">Términos y Condiciones de Uso (Contrato de Adhesión)</h5>
													<span>Descargar</span>
												</Link>
												<Link to="#" className="download-link">
													<img src={doc} alt=""/>
													<h5 className="title">Aviso de Privacidad (Política de Tratamiento de Datos)</h5>
													<span>Descargar</span>
												</Link>
											</div>
										</div>
										
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				
			</>
		);
	}
}

export default ServiceDetail;